var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 61,
    viewBox: "0 0 203 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3811_4123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3811_4123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3811_4123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.359 0.751465H7.51388C3.7791 0.751465 0.751465 3.7791 0.751465 7.51388V52.5966C0.751465 56.3314 3.7791 59.3591 7.51388 59.3591H195.359C199.094 59.3591 202.121 56.3314 202.121 52.5966V7.51388C202.121 3.7791 199.094 0.751465 195.359 0.751465Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.359 0.751465H7.51388C3.7791 0.751465 0.751465 3.7791 0.751465 7.51388V52.5966C0.751465 56.3314 3.7791 59.3591 7.51388 59.3591H195.359C199.094 59.3591 202.121 56.3314 202.121 52.5966V7.51388C202.121 3.7791 199.094 0.751465 195.359 0.751465Z",
    stroke: "#A6A6A6",
    strokeWidth: 1.50276
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.393 32.6864C98.859 32.6864 95.9782 35.3748 95.9782 39.0776C95.9782 42.7579 98.859 45.4689 102.393 45.4689C105.929 45.4689 108.81 42.7579 108.81 39.0776C108.809 35.3748 105.928 32.6864 102.393 32.6864ZM102.393 42.9533C100.456 42.9533 98.7869 41.3558 98.7869 39.0791C98.7869 36.7784 100.458 35.205 102.393 35.205C104.331 35.205 106 36.7784 106 39.0791C106 41.3543 104.331 42.9533 102.393 42.9533ZM88.3968 32.6864C84.8623 32.6864 81.9815 35.3748 81.9815 39.0776C81.9815 42.7579 84.8623 45.4689 88.3968 45.4689C91.9328 45.4689 94.8136 42.7579 94.8136 39.0776C94.8136 35.3748 91.9328 32.6864 88.3968 32.6864ZM88.3968 42.9533C86.4597 42.9533 84.7902 41.3558 84.7902 39.0791C84.7902 36.7784 86.4612 35.205 88.3968 35.205C90.3338 35.205 92.0034 36.7784 92.0034 39.0791C92.0049 41.3543 90.3338 42.9533 88.3968 42.9533ZM71.7492 34.649V37.36H78.2381C78.0443 38.8853 77.5364 39.9988 76.7609 40.7728C75.8172 41.7165 74.34 42.7579 71.7492 42.7579C67.7549 42.7579 64.6322 39.5375 64.6322 35.5432C64.6322 31.5488 67.7549 28.3284 71.7492 28.3284C73.9042 28.3284 75.4776 29.176 76.6392 30.2655L78.5522 28.3525C76.9292 26.8031 74.7758 25.6174 71.7492 25.6174C66.2777 25.6174 61.6777 30.0716 61.6777 35.5432C61.6777 41.0147 66.2777 45.4689 71.7492 45.4689C74.7021 45.4689 76.9307 44.4996 78.6724 42.6843C80.4637 40.893 81.0212 38.3744 81.0212 36.3411C81.0212 35.713 80.9732 35.1314 80.8755 34.6475L71.7492 34.649ZM139.836 36.7544C139.304 35.3268 137.681 32.6864 134.365 32.6864C131.072 32.6864 128.336 35.2772 128.336 39.0776C128.336 42.6602 131.048 45.4689 134.679 45.4689C137.608 45.4689 139.303 43.6776 140.006 42.6362L137.827 41.183C137.101 42.2485 136.108 42.9503 134.679 42.9503C133.251 42.9503 132.234 42.2966 131.58 41.0132L140.126 37.4787L139.836 36.7544ZM131.12 38.8853C131.048 36.4148 133.033 35.1569 134.462 35.1569C135.576 35.1569 136.52 35.7145 136.835 36.5124L131.12 38.8853ZM124.173 45.0827H126.98V26.2967H124.173V45.0827ZM119.572 34.1155H119.475C118.846 33.3642 117.634 32.6864 116.111 32.6864C112.914 32.6864 109.985 35.4951 109.985 39.1032C109.985 42.6858 112.914 45.4704 116.111 45.4704C117.636 45.4704 118.846 44.7926 119.475 44.0187H119.572V44.9384C119.572 47.3834 118.264 48.6908 116.159 48.6908C114.44 48.6908 113.374 47.457 112.938 46.4156L110.493 47.433C111.195 49.1266 113.059 51.2094 116.159 51.2094C119.451 51.2094 122.236 49.2724 122.236 44.5507V33.0756H119.573L119.572 34.1155ZM116.353 42.9533C114.416 42.9533 112.794 41.3303 112.794 39.1032C112.794 36.8506 114.416 35.205 116.353 35.205C118.264 35.205 119.765 36.8506 119.765 39.1032C119.765 41.3303 118.264 42.9533 116.353 42.9533ZM152.991 26.2967H146.273V45.0827H149.075V37.9656H152.99C156.098 37.9656 159.154 35.716 159.154 32.1319C159.154 28.5478 156.099 26.2967 152.991 26.2967ZM153.064 35.3508H149.075V28.9115H153.064C155.16 28.9115 156.35 30.6472 156.35 32.1319C156.35 33.5866 155.16 35.3508 153.064 35.3508ZM170.393 32.6534C168.363 32.6534 166.261 33.5475 165.391 35.5296L167.879 36.568C168.411 35.5296 169.403 35.19 170.441 35.19C171.892 35.19 173.366 36.0601 173.39 37.6064V37.8003C172.882 37.5103 171.794 37.076 170.465 37.076C167.783 37.076 165.051 38.5502 165.051 41.3047C165.051 43.8188 167.251 45.4373 169.716 45.4373C171.6 45.4373 172.64 44.5913 173.292 43.5994H173.388V45.0496H176.096V37.8469C176.098 34.5138 173.606 32.6534 170.393 32.6534ZM170.054 42.9488C169.137 42.9488 167.855 42.4889 167.855 41.3528C167.855 39.9027 169.451 39.3466 170.829 39.3466C172.06 39.3466 172.641 39.6126 173.39 39.9748C173.172 41.7165 171.674 42.9488 170.054 42.9488ZM185.957 33.0636L182.743 41.2086H182.647L179.311 33.0636H176.29L181.293 44.447L178.441 50.7796H181.365L189.076 33.0636H185.957ZM160.702 45.0827H163.505V26.2967H160.702V45.0827Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2573 15.3932C71.2573 16.6525 70.8847 17.6548 70.1378 18.4032C69.2902 19.2928 68.1842 19.7376 66.8257 19.7376C65.5243 19.7376 64.4168 19.2868 63.5076 18.3851C62.5969 17.482 62.1416 16.3639 62.1416 15.0295C62.1416 13.6935 62.5969 12.5755 63.5076 11.6738C64.4168 10.7707 65.5243 10.3198 66.8257 10.3198C67.4719 10.3198 68.0895 10.4461 68.6756 10.697C69.2632 10.9495 69.7335 11.2846 70.0852 11.7039L69.2932 12.4973C68.6966 11.7835 67.8746 11.4274 66.8242 11.4274C65.8745 11.4274 65.054 11.761 64.3612 12.4282C63.6684 13.0954 63.3228 13.9625 63.3228 15.028C63.3228 16.0934 63.6684 16.9605 64.3612 17.6278C65.054 18.295 65.8745 18.6286 66.8242 18.6286C67.831 18.6286 68.6711 18.2935 69.3428 17.6217C69.7786 17.1844 70.0311 16.5758 70.0987 15.7959H66.8242V14.7124H71.1927C71.2378 14.9483 71.2573 15.1753 71.2573 15.3932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1851 11.6273H74.0795V14.4856H77.7823V15.569H74.0795V18.4272H78.1851V19.5363H72.9209V10.5198H78.1851V11.6273Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0703 19.5363H81.9117V11.6273H79.3931V10.5198H85.5889V11.6273H83.0703V19.5363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0718 19.5363V10.5198H91.2304V19.5363H90.0718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3687 19.5363H95.21V11.6273H92.6914V10.5198H98.8873V11.6273H96.3687V19.5363Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.616 18.3716C109.729 19.2823 108.628 19.7376 107.31 19.7376C105.992 19.7376 104.89 19.2823 104.005 18.3716C103.119 17.461 102.677 16.3459 102.677 15.028C102.677 13.7101 103.119 12.5951 104.005 11.6844C104.89 10.7737 105.992 10.3169 107.31 10.3169C108.62 10.3169 109.72 10.7752 110.61 11.6904C111.499 12.6056 111.944 13.7176 111.944 15.028C111.944 16.3459 111.501 17.461 110.616 18.3716ZM104.86 17.6157C105.527 18.292 106.343 18.6286 107.31 18.6286C108.276 18.6286 109.094 18.2905 109.759 17.6157C110.426 16.9395 110.762 16.0769 110.762 15.028C110.762 13.9791 110.426 13.1165 109.759 12.4403C109.094 11.7641 108.276 11.4274 107.31 11.4274C106.343 11.4274 105.527 11.7656 104.86 12.4403C104.195 13.1165 103.859 13.9791 103.859 15.028C103.859 16.0769 104.195 16.9395 104.86 17.6157Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57 19.5363V10.5198H114.98L119.362 17.5331H119.412L119.362 15.7959V10.5198H120.521V19.5363H119.311L114.726 12.1818H114.676L114.726 13.919V19.5363H113.57Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.2573 15.3932C71.2573 16.6525 70.8847 17.6548 70.1378 18.4032C69.2902 19.2928 68.1842 19.7376 66.8257 19.7376C65.5243 19.7376 64.4168 19.2868 63.5076 18.3851C62.5969 17.482 62.1416 16.3639 62.1416 15.0295C62.1416 13.6935 62.5969 12.5755 63.5076 11.6738C64.4168 10.7707 65.5243 10.3198 66.8257 10.3198C67.4719 10.3198 68.0895 10.4461 68.6756 10.697C69.2632 10.9495 69.7335 11.2846 70.0852 11.7039L69.2932 12.4973C68.6966 11.7835 67.8746 11.4274 66.8242 11.4274C65.8745 11.4274 65.054 11.761 64.3612 12.4282C63.6684 13.0954 63.3228 13.9625 63.3228 15.028C63.3228 16.0934 63.6684 16.9605 64.3612 17.6278C65.054 18.295 65.8745 18.6286 66.8242 18.6286C67.831 18.6286 68.6711 18.2935 69.3428 17.6217C69.7786 17.1844 70.0311 16.5758 70.0987 15.7959H66.8242V14.7124H71.1927C71.2378 14.9483 71.2573 15.1753 71.2573 15.3932Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1851 11.6273H74.0795V14.4856H77.7823V15.569H74.0795V18.4272H78.1851V19.5363H72.9209V10.5198H78.1851V11.6273Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0703 19.5363H81.9117V11.6273H79.3931V10.5198H85.5889V11.6273H83.0703V19.5363Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0718 19.5363V10.5198H91.2304V19.5363H90.0718Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.3687 19.5363H95.21V11.6273H92.6914V10.5198H98.8873V11.6273H96.3687V19.5363Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.616 18.3716C109.729 19.2823 108.628 19.7376 107.31 19.7376C105.992 19.7376 104.89 19.2823 104.005 18.3716C103.119 17.461 102.677 16.3459 102.677 15.028C102.677 13.7101 103.119 12.5951 104.005 11.6844C104.89 10.7737 105.992 10.3169 107.31 10.3169C108.62 10.3169 109.72 10.7752 110.61 11.6904C111.499 12.6056 111.944 13.7176 111.944 15.028C111.944 16.3459 111.501 17.461 110.616 18.3716ZM104.86 17.6157C105.527 18.292 106.343 18.6286 107.31 18.6286C108.276 18.6286 109.094 18.2905 109.759 17.6157C110.426 16.9395 110.762 16.0769 110.762 15.028C110.762 13.9791 110.426 13.1165 109.759 12.4403C109.094 11.7641 108.276 11.4274 107.31 11.4274C106.343 11.4274 105.527 11.7656 104.86 12.4403C104.195 13.1165 103.859 13.9791 103.859 15.028C103.859 16.0769 104.195 16.9395 104.86 17.6157Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.57 19.5363V10.5198H114.98L119.362 17.5331H119.412L119.362 15.7959V10.5198H120.521V19.5363H119.311L114.726 12.1818H114.676L114.726 13.919V19.5363H113.57Z",
    stroke: "white",
    strokeWidth: 0.300552,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3811_4123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6822 11.3275C15.2449 11.7903 14.9863 12.5086 14.9863 13.4389V46.6738C14.9863 47.6055 15.2449 48.3223 15.6822 48.7852L15.7934 48.8934L34.411 30.2757V30.0563V29.8369L15.7934 11.2178L15.6822 11.3275Z",
    fill: "url(#paint0_linear_3811_4123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6155 36.4835L34.4106 30.2756V30.0562V29.8368L40.617 23.6304L40.7568 23.71L48.1098 27.8877C50.2091 29.0809 50.2091 31.033 48.1098 32.2277L40.7568 36.4053L40.6155 36.4835Z",
    fill: "url(#paint1_linear_3811_4123)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3811_4123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7567 36.4043L34.409 30.0566L15.6816 48.7855C16.3729 49.5189 17.5165 49.609 18.8044 48.8787L40.7567 36.4043Z",
    fill: "url(#paint2_linear_3811_4123)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.7567 23.7087L18.8044 11.2358C17.5165 10.5039 16.3729 10.5956 15.6816 11.3289L34.4105 30.0578L40.7567 23.7087Z",
    fill: "url(#paint3_linear_3811_4123)"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3811_4123",
    x: 14.9863,
    y: 10.5053,
    width: 34.6978,
    height: 39.1032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.225414
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3811_4123"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.225414
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3811_4123",
    result: "effect2_dropShadow_3811_4123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3811_4123",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3811_4123",
    x: 15.6816,
    y: 29.8312,
    width: 25.0752,
    height: 19.5518,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.225414
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3811_4123"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3811_4123",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3811_4123",
    x1: 32.7607,
    y1: 13.0872,
    x2: 7.54136,
    y2: 38.3064,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3811_4123",
    x1: 50.8426,
    y1: 30.0562,
    x2: 14.482,
    y2: 30.0562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3811_4123",
    x1: 37.3095,
    y1: 33.5038,
    x2: 3.10904,
    y2: 67.7044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3811_4123",
    x1: 10.9652,
    y1: 0.265316,
    x2: 26.2366,
    y2: 15.5368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3811_4123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.872,
    height: 60.1104,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3811_4123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.872,
    height: 60.1104,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3811_4123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 202.872,
    height: 60.1104,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.a844aa96561efbc8f20e20d8846922df.svg";
export { ForwardRef as ReactComponent };